export const ModalChangePasswordTranslationsUk = {
  changePassword: 'Змінити пароль',
  yourPassword: 'Ваш пароль',
  newPassword: 'Новий пароль',
  'Enter new password': 'Введіть новий пароль ще раз',
  saveButton: 'Зберегти',
};
